import React from "react";
import "./AboutUs.css";
import { FaVial, FaPills, FaHeartbeat } from "react-icons/fa";
import { FaLocationPin } from "react-icons/fa6";

function About() {
  return (
    <section id="about" className="about">

      <div className="about-container container">

        {/* LEFT IMAGE */}
        <div className="about-image">
          <div className="video-wrapper">
            <iframe
              src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fluksmedikus%2Fvideos%2F216286578881547%2F&show_text=false&width=560&t=0"
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              allowFullScreen
              title="Facebook Video"
            ></iframe>
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="about-content">

          <h2>ЗА НАС</h2>

          <p className="about-text">
            ПЗУ ЛУКС МЕДИКУС е овластена специјалистичка ординација по медицина на труд, која обезбедува висококвалитетни здравствени услуги со современ пристап и професионален медицински тим.
            Вршиме систематски прегледи, биохемиски анализи, клинички прегледи, хематолошки и уринарни испитувања, како и други специјализирани медицински услуги.
          </p>

          <div className="about-item">

            <FaVial className="icon" />

            <div >
              <h4>Систематски и дијагностички прегледи</h4>
              <p>Вршиме комплетни систематски прегледи и лабораториски анализи според современи медицински стандарди.</p>

            </div>

          </div>

          <div className="about-item">

            <FaPills className="icon" />

            <div>
              <h4>Овластена специјалистичка ординација</h4>
              <p>Работиме согласно решение од Министерството за здравство на Р. Македонија под број 22-9117/2.</p>

            </div>

          </div>

          <div className="about-item">
            <FaLocationPin className="icon" />
            <div>
              <h4>Локација и опрема</h4>
              <p>Ординацијата се наоѓа во Карпош, Скопје, на ул. Козле бр.88/4 и располага со современа медицинска опрема.</p>
            </div>
          </div>

          <div className="about-item">
            <FaHeartbeat className="icon" />
            <div>
              <h4>Доверливост и професионалност</h4>
              <p>За сите извршени прегледи се издава медицинско мислење со гарантирана тајност на податоците.</p>
            </div>
          </div>

        </div>
      </div>

    </section>
  );
}

export default About;
